import React from "react";
import { FiX } from "react-icons/fi";

interface ConfirmModalProps {
    open: boolean;
    title: string;
    description?: React.ReactNode;
    icon?: React.ReactNode;
    iconBgColor?: string;
    confirmText?: string;
    cancelText?: string;
    loading?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    open,
    title,
    description,
    icon,
    iconBgColor = "bg-red-100",
    confirmText = "Confirm",
    cancelText = "Cancel",
    loading = false,
    onConfirm,
    onClose,
}) => {
    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"  style={{ marginTop: '0px' }}>
            <div
                className="bg-white rounded-lg p-6 max-w-md w-full mx-4 relative"
                role="dialog"
                aria-modal="true"
            >
                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
                    aria-label="Close"
                >
                    <FiX />
                </button>

                {/* Icon */}
                {icon && (
                    <div className={`w-16 h-16 ${iconBgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
                        {icon}
                    </div>
                )}

                {/* Title */}
                <h2 className="text-xl font-semibold mb-3 text-center">
                    {title}
                </h2>

                {/* Description */}
                {description && (
                    <p className="text-gray-600 text-sm mb-6 text-center">
                        {description}
                    </p>
                )}

                {/* Actions */}
                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="flex-1 border border-gray-300 text-gray-700 py-3 rounded-lg hover:bg-gray-50 transition disabled:opacity-60"
                    >
                        {cancelText}
                    </button>

                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        className="flex-1 bg-red-600 text-white py-3 rounded-lg hover:bg-red-700 transition disabled:opacity-60"
                    >
                        {loading ? "Processing..." : confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
